export type MarketPage = 'overview' | 'gold' | 'forex' | 'diamond';

export const MARKET_PAGES = {
  overview: {
    path: '/bang-gia/', label: 'Bảng giá', title: 'Bảng giá vàng, tỷ giá ngoại tệ và giá kim cương',
    description: 'Tra cứu giá vàng trong nước, tỷ giá ngoại tệ Vietcombank và công cụ tham khảo giá kim cương tự nhiên. Có nguồn dữ liệu, đơn vị và thời gian cập nhật.',
    heading: 'Bảng giá tham khảo.', intro: 'Giá vàng trong nước, tỷ giá ngoại tệ và giá tham khảo kim cương quốc tế.',
  },
  gold: {
    path: '/bang-gia/gia-vang/', label: 'Giá vàng', title: 'Giá vàng hôm nay: bảng giá mua vào, bán ra',
    description: 'Bảng giá vàng mua vào, bán ra theo thương hiệu trong nước, đơn vị nghìn đồng/chỉ. Xem biến động, nguồn tham khảo và thời gian cập nhật dữ liệu.',
    heading: 'Giá vàng hôm nay.', intro: 'Theo dõi giá mua vào, bán ra và biến động theo từng thương hiệu trong nước.',
  },
  forex: {
    path: '/bang-gia/ty-gia/', label: 'Tỷ giá ngoại tệ', title: 'Tỷ giá ngoại tệ Vietcombank: USD, EUR, JPY và các đồng khác',
    description: 'Tra cứu tỷ giá ngoại tệ Vietcombank: USD, EUR, JPY, CNY, KRW và các đồng khác. So sánh mua tiền mặt, chuyển khoản và bán ra theo VND.',
    heading: 'Tỷ giá ngoại tệ.', intro: 'So sánh giá mua tiền mặt, mua chuyển khoản và bán ra theo nguồn Vietcombank.',
  },
  diamond: {
    path: '/bang-gia/kim-cuong/', label: 'Giá kim cương', title: 'Giá kim cương tự nhiên: tra cứu theo 4C và báo cáo GIA',
    description: 'Tham khảo giá kim cương tự nhiên theo carat, màu sắc, độ tinh khiết và giác cắt từ StoneAlgo. Nhập số báo cáo để đối chiếu tại GIA Report Check.',
    heading: 'Giá kim cương tự nhiên.', intro: 'Tham khảo giá theo thông số 4C và đối chiếu thông tin báo cáo GIA của viên đá.',
  },
} as const;

export const GIA_LOOKUP_HREF = `${MARKET_PAGES.diamond.path}#tra-cuu-gia`;

export const MARKET_FRAGMENT_PAGES: Record<string, Exclude<MarketPage, 'overview'>> = {
  'gia-vang': 'gold', 'bang-gia-vang': 'gold', 'ty-gia-usd': 'forex', 'ty-gia': 'forex', 'gia-kim-cuong': 'diamond',
};

export const marketFragmentPath = (fragment: string): string | null => {
  if (!Object.prototype.hasOwnProperty.call(MARKET_FRAGMENT_PAGES, fragment)) return null;
  return MARKET_PAGES[MARKET_FRAGMENT_PAGES[fragment]].path;
};
